/* Existing Shopify/Dawn cart transport and drawer; no additional pixel or purchase event. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-gift-link]').forEach(link => {
      const destination = new URL(link.getAttribute('href'), location.origin);
      if (destination.origin !== location.origin) return;
      const source = new URLSearchParams(location.search);
      // Only non-personal campaign identifiers. Never forward an arbitrary query string.
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'gclid', 'gbraid', 'wbraid', 'msclkid'].forEach(key => {
        const value = source.get(key);
        if (value && value.length <= 200 && /^[A-Za-z0-9._~+\- ]+$/.test(value) && !destination.searchParams.has(key)) destination.searchParams.set(key, value);
      });
      link.href = destination.pathname + destination.search + destination.hash;
    });
    root.querySelectorAll('[data-gift-multiple]').forEach(container => {
      if (container.dataset.quantityReady) return;
      container.dataset.quantityReady = 'true';
      const input = container.querySelector('[name="quantity"]');
      const options = container.querySelectorAll('[data-gift-quantity]');
      const steppers = container.querySelectorAll('[data-gift-step]');
      const total = container.querySelector('[data-gift-total]');
      const original = container.querySelector('[data-gift-original]');
      const savings = container.querySelector('[data-gift-savings]');
      const label = container.querySelector('[data-gift-add-label]');
      const submit = container.querySelector('[type="submit"]');
      const minimum = Number(input.min) || 1;
      const step = Number(input.step) || 1;
      const maximum = input.max ? Number(input.max) : Infinity;
      const allowed = quantity => Number.isSafeInteger(quantity) && quantity >= minimum && quantity <= maximum && (quantity - minimum) % step === 0;
      const money = new Intl.NumberFormat(container.dataset.locale || 'en', {style:'currency',currency:container.dataset.currency,currencyDisplay:'symbol'});
      const tiers = (container.dataset.giftTiers || '').split(',').map(tier => tier.split(':').map(Number)).filter(([minimum, percent]) => Number.isSafeInteger(minimum) && minimum > 1 && percent > 0 && percent < 100).sort((a,b) => b[0] - a[0]);
      function update() {
        const quantity = Number(input.value);
        const valid = allowed(quantity);
        const percent = valid ? (tiers.find(([minimum]) => quantity >= minimum)?.[1] || 0) : 0;
        const unitPrice = Number(container.dataset.unitPrice);
        // Shopify's percentage allocation rounds each unit's discount down to a cent.
        // Verified against anonymous carts for this existing bundle at quantities 1–5.
        const unitSavings = Math.floor(unitPrice * percent / 100);
        options.forEach(button => {
          const preset = Number(button.dataset.giftQuantity);
          const selected = button.hasAttribute('data-gift-quantity-minimum') ? quantity >= preset : quantity === preset;
          button.setAttribute('aria-pressed', String(valid && selected));
        });
        steppers.forEach(button => {
          const next = valid ? quantity + Number(button.dataset.giftStep) * step : minimum;
          button.disabled = submit.disabled || !allowed(next);
        });
        total.textContent = valid ? money.format((unitPrice - unitSavings) * quantity / 100) : 'Choose a valid quantity';
        if (original) {
          original.hidden = !valid || !percent;
          original.textContent = valid && percent ? money.format(unitPrice * quantity / 100) : '';
        }
        if (savings) savings.textContent = valid && percent ? `${percent}% discount · Save ${money.format(unitSavings * quantity / 100)}` : '';
        if (!submit.disabled) label.textContent = 'ADD TO CART';
      }
      options.forEach(button => {
        button.disabled = submit.disabled || !allowed(Number(button.dataset.giftQuantity));
        button.addEventListener('click', () => {
          if (button.disabled || container.busy) return;
          input.value = button.dataset.giftQuantity;
          input.dispatchEvent(new Event('change', {bubbles:true}));
        });
      });
      steppers.forEach(button => button.addEventListener('click', () => {
        if (button.disabled || container.busy) return;
        const quantity = Number(input.value);
        const next = allowed(quantity) ? quantity + Number(button.dataset.giftStep) * step : minimum;
        if (!allowed(next)) return;
        input.value = next;
        input.dispatchEvent(new Event('change', {bubbles:true}));
      }));
      input.addEventListener('input', update);
      input.addEventListener('change', update);
      update();
    });
    root.querySelectorAll('[data-gift-gallery]').forEach(gallery => {
      if (gallery.dataset.galleryReady) return;
      gallery.dataset.galleryReady = 'true';
      const track = gallery.querySelector('[data-gift-gallery-track]');
      const slides = [...gallery.querySelectorAll('[data-gift-slide]')];
      const thumbnails = [...gallery.querySelectorAll('[data-gift-photo]')];
      const previous = gallery.querySelector('[data-gift-gallery-previous]');
      const next = gallery.querySelector('[data-gift-gallery-next]');
      const position = gallery.querySelector('[data-gift-gallery-position]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0;
      let requestedIndex = null;
      let scrollTimer;
      const select = index => {
        current = Math.max(0, Math.min(slides.length - 1, index));
        thumbnails.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
        if (previous) previous.disabled = current === 0;
        if (next) next.disabled = current === slides.length - 1;
        if (position) position.textContent = `${current + 1} / ${slides.length}`;
        const thumbnail = thumbnails[current];
        if (thumbnail) {
          const row = thumbnail.parentElement;
          const left = thumbnail.offsetLeft - thumbnails[0].offsetLeft;
          if (left < row.scrollLeft) row.scrollLeft = left;
          else if (left + thumbnail.offsetWidth > row.scrollLeft + row.clientWidth) row.scrollLeft = left + thumbnail.offsetWidth - row.clientWidth;
        }
      };
      const goTo = index => {
        select(index);
        requestedIndex = current;
        track.scrollTo({left: current * track.clientWidth, behavior: reducedMotion.matches ? 'auto' : 'smooth'});
      };
      previous?.addEventListener('click', () => goTo(current - 1));
      next?.addEventListener('click', () => goTo(current + 1));
      thumbnails.forEach((button, index) => button.addEventListener('click', () => goTo(index)));
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          if (!track.clientWidth) return;
          const visibleIndex = Math.round(track.scrollLeft / track.clientWidth);
          if (requestedIndex !== null && visibleIndex !== requestedIndex) return;
          requestedIndex = null;
          select(visibleIndex);
        }, 100);
      }, {passive:true});
      ['pointerdown', 'wheel'].forEach(event => track.addEventListener(event, () => {requestedIndex = null;}, {passive:true}));
      track.addEventListener('keydown', event => {
        const targets = {ArrowLeft: current - 1, ArrowRight: current + 1, Home: 0, End: slides.length - 1};
        if (!(event.key in targets) || event.altKey || event.ctrlKey || event.metaKey) return;
        event.preventDefault();
        goTo(targets[event.key]);
      });
      if ('ResizeObserver' in window) new ResizeObserver(() => {
        clearTimeout(scrollTimer);
        track.scrollTo({left: current * track.clientWidth, behavior:'auto'});
      }).observe(track);
      gallery.querySelectorAll('[data-gift-gallery-controls], [data-gift-gallery-thumbnails]').forEach(element => {element.hidden = false;});
      select(0);
    });
    root.querySelectorAll('[data-gift-photo]').forEach(button => {
      if (button.closest('[data-gift-gallery]')) return;
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const gallery = button.closest('.cd-gift-gallery');
        const image = button.querySelector('img').cloneNode(true);
        image.sizes = '(min-width: 990px) 48vw, 92vw';
        image.loading = 'eager';
        gallery.querySelector('[data-gift-main-image]').replaceChildren(image);
        gallery.querySelectorAll('[data-gift-photo]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      });
    });
    root.querySelectorAll('[data-gift-play]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const container = button.closest('[data-gift-video]');
        const fragment = container.querySelector('template').content.cloneNode(true);
        container.replaceChildren(fragment);
        const video = container.querySelector('video');
        const player = video || container.querySelector('iframe');
        player.focus();
        if (video) video.play().catch(() => {});
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  customElements.whenDefined('product-form').then(() => {
    if (customElements.get('cd-gift-product-form')) return;
    customElements.define('cd-gift-product-form', class extends customElements.get('product-form') {
      async onSubmitHandler(event) {
        event.preventDefault();
        if (this.busy || this.submitButton.disabled || !this.form.reportValidity()) return;
        this.busy = true;
        this.handleErrorMessage();
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        spinner.classList.remove('hidden');
        const status = this.querySelector('[role="status"]');
        status.textContent = '';
        const data = new FormData(this.form);
        // Exactly one existing bundle variant per selected quantity; retain the rest of the cart.
        if (this.cart) {
          data.append('sections', this.cart.getSectionsToRender().map(section => section.id).join(','));
          data.append('sections_url', location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        let confirmed = false;
        try {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = data;
          const response = await fetch(routes.cart_add_url, config);
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'The kit could not be added. Please try again.');
          // A bundle can be represented as items or as a parent line in the response.
          if (!result.id && !result.items?.length) throw new Error('The cart response could not be confirmed. Please check your cart before retrying.');
          confirmed = true;
          const giftCount = Number(data.get('quantity'));
          status.textContent = `${giftCount} Gift ${giftCount === 1 ? 'Kit' : 'Kits'} added. ${giftCount} free Mini Golf ${giftCount === 1 ? 'Brush' : 'Brushes'} included.`;
          publish(PUB_SUB_EVENTS.cartUpdate, {source:'product-form',productVariantId:data.get('id'),cartData:result});
          if (this.cart && result.sections) {
            try {
              this.cart.classList.remove('is-empty');
              this.cart.renderContents(result);
            } catch (_) {
              status.textContent = 'Gift kit added. Open Cart to review your items.';
            }
          } else {
            window.location.assign(routes.cart_url);
          }
        } catch (error) {
          if (!confirmed) {
            this.handleErrorMessage(error instanceof TypeError ? 'Connection interrupted. Check your cart before trying again; your request may have reached Shopify.' : error.message);
            publish(PUB_SUB_EVENTS.cartError, {source:'product-form',productVariantId:data.get('id'),message:error.message});
          }
        } finally {
          this.busy = false;
          this.submitButton.disabled = false;
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          spinner.classList.add('hidden');
        }
      }
    });
  });
})();
